import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ForPlanDirective } from '@directives';
import { AppRoute } from '@enums';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';

@Component({
    selector: 'app-premium-only-message',
    imports: [MessageModule, ButtonModule, ForPlanDirective, RouterLink],
    templateUrl: './premium-only-message.component.html',
    styleUrl: './premium-only-message.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PremiumOnlyMessageComponent {
    public readonly label = input<string>(
        `This functionality available only for the Premium Users.`
    );

    protected readonly billingPageUrl = `/${AppRoute.Root.Billing}`;
}
